<emr-modal headerTitle="Suspend/Resume Alerts" [bsModalRef]=bsAlertSuppressionModalRef>
  <div modal-body class="col-md-12">
    <app-alert-suppression [alertSuspendStatusRequest]="alertSuspendStatusRequest"  (CloseClick)="onPopupCancel()"></app-alert-suppression>
  </div>
</emr-modal>